// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buttonStyles-cls1___95cb22b05227b15c265{/*!*/}.buttonStyles-cls2__fef8a184c28591b72df5{margin:2px;flex-grow:1;display:flex;align-items:center;justify-content:center;min-height:24px}.buttonStyles-cls2__fef8a184c28591b72df5>img{max-height:20px;max-width:18px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "buttonStyles-cls1___95cb22b05227b15c265",
	"cls2": "buttonStyles-cls2__fef8a184c28591b72df5 buttonStyles-cls1___95cb22b05227b15c265"
};
export default ___CSS_LOADER_EXPORT___;
